import React from 'react'
import './DesktopModalPWA.css'
import CircledClose from 'SVGPath/circledClose.svg'

const DesktopModalPWA = ({ content = null, children = null, header, showFlag, onCloseModal }) => {
  const closeModal = e => {
    e.stopPropagation()
    e.preventDefault()
    onCloseModal()
  }
  return (
    <div className={showFlag ? 'desktop-modal-case' : 'hide'}>
      <div className="desktop-modal-container-case">
        <div className="flex flex-between flex-middle desktop-modal-header-case py-3">
          <p className="flex-1 fs-24 fw-600 px-8 py-4">{header}</p>
          <span className="desktop-modal-close-case px-8" onClick={closeModal}>
            <CircledClose />
          </span>
        </div>
        <If condition={content || children}>
          <div className="desktop-modal-body-case pl-8">{content || children}</div>
        </If>
      </div>
    </div>
  )
}

export default DesktopModalPWA
